module.exports = __webpack_public_path__ + "img/why-icon-1.4971aef4.svg";